module.exports = __webpack_public_path__ + "img/logo.ebb0a643.png";